import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fadeInUp400ms } from "src/app/shared/animations/fade-in-up.animation";
import { OAuthService } from "angular-oauth2-oidc";

@Component({
  selector: "vex-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInUp400ms],
})
export class LoginComponent implements OnInit {
  form: UntypedFormGroup;

  inputType = "password";
  visible = false;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private oauthService:OAuthService,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });
    
    this.login();
  }

  login(){
    this.oauthService.initLoginFlow();
  }

  // send() {
  //   this.router.navigate(["/"]);
  //   this.snackbar.open(
  //     "Lucky you! Looks like you didn't need a password or email address! For a real application we provide validators to prevent this. ;)",
  //     "LOL THANKS",
  //     {
  //       duration: 10000,
  //     }
  //   );
  //   this.login();
  // }

  // toggleVisibility() {
  //   if (this.visible) {
  //     this.inputType = "password";
  //     this.visible = false;
  //     this.cd.markForCheck();
  //   } else {
  //     this.inputType = "text";
  //     this.visible = true;
  //     this.cd.markForCheck();
  //   }
  // }
}
